// submitAnonymousLogin.js
'use strict';
import fetch from '../resource/customFetch.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';
import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';
import handleLoginToken from '../action/handleLoginToken.js';
import fetchAccessToken, { viaTypes } from '../action/fetchAccessToken.js';
import setRandomRegisterUsername from '../action/setRandomRegisterUsername.js';
import getMeData from '../selector/getMeData.js';
import getRegisterData from '../selector/getRegisterData.js';

/**
 * Submit anonymous login
 * @kind action
 * @return {Promise} Action promise.
 */
const submitAnonymousLogin = () => async (dispatch, getState) => {
  const selectPath = ['submit', 'login', 'anonymous'];

  dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

  try {
    await dispatch(setRandomRegisterUsername());
    const username = getRegisterData(getState(), 'username');

    if (!username) {
      throw new Error('Failed to generate available username');
    }

    const url = getResourceUrl({ endpoint: '/login/anonymous' });
    const fetchOptions = {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username }),
    };

    const response = await fetch(url.href, fetchOptions);
    if (!response.ok) {
      await handleFetchError({ response });
    }

    const { refresh_token: refreshToken } = await response.json();

    let token;
    if (refreshToken) {
      await dispatch(
        fetchAccessToken({ refreshToken, via: viaTypes.JWT_LOGIN })
      );
      token = getMeData(getState(), 'token');
    }

    if (!token) {
      throw new Error('Failed to get access token');
    }

    dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
    return dispatch(handleLoginToken({ token }));
  } catch (error) {
    return dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { error, selectPath },
    });
  }
};

export default submitAnonymousLogin;
